module.exports = "https://www.niulinkcloud.cn/_next/static/media/icon1.9eed6969e17f4facf4e5a02bbc7293a3.png";